import React, {Component} from 'react'
import PropTypes from "prop-types"
import {Button} from 'react-bootstrap'
import {IndexLinkContainer} from 'react-router-bootstrap'
import logo from '../resources/images/logo.png'

class Header extends Component {

	render() {
		const {headerContent} = this.props;

		return (
			<header id="header">
				<IndexLinkContainer to="/">
					<Button bsStyle="link" className="logo">
						<img src={logo} alt="Český Biatlon Online"/>
					</Button>
				</IndexLinkContainer>
				<div id="sub-logo">
					<span>Online</span>
					výsledky
				</div>
				{headerContent}
			</header>
		)
	}
}

Header.propTypes = {
	headerContent: PropTypes.node
};

export default Header


// WEBPACK FOOTER //
// ./P:/Work/htdocs/biatlon/online/src/components/Header.js